import { Action, configureStore, ThunkAction } from "@reduxjs/toolkit";
import createInviteReducer from "../redux/user/createInviteSlice";
import userInviteReducer from "../redux/user/userInviteSlice";
import userPermissionInsDel from "../redux/user/userPermissionInsDelSlice";
import userReducer from "../redux/user/userSlice";
import usersForPermissions from "../redux/user/usersForPermissionsSlice";
import usersPermissionsIns from "../redux/user/usersPermissionsInsSlice";
import usersQuery from "../redux/user/usersQuerySlice";

import schoolClassroomsReducer from "../redux/school/schoolClassroomsSlice";
import schoolDptosReducer from "../redux/school/schoolDptosSlice";
import schoolInsUpdReducer from "../redux/school/schoolInsUpdSlice";
import schoolRoutinesReducer from "../redux/school/schoolRoutinesSlice";
import schoolReducer from "../redux/school/schoolSlice";
import schoolStudentsReducer from "../redux/school/schoolStudentsSlice";
import schoolsReducer from "../redux/school/schoolsSlice";

import classroomInsUpdReducer from "../redux/classroom/classroomInsUpdSlice";
import classroomRemoveStudentReducer from "../redux/classroom/classroomRemoveStudentSlice";
import classroomReducer from "../redux/classroom/classroomSlice";
import classroomAddStudentReducer from "../redux/classroom/classroomStudentAddSlice";
import classroomStudentInvitesReducer from "../redux/classroom/classroomStudentInvitesSlice";
import classroomStudentsReducer from "../redux/classroom/classroomStudentsSlice";

import studentInviteReducer from "../redux/student/getStudentInviteSlice";
import studentClassroomsReducer from "../redux/student/studentClassroomsSlice";
import studentInsUpdReducer from "../redux/student/studentInsUpdSlice";
import studentSchoolsReducer from "../redux/student/studentSchoolsSlice";
import studentReducer from "../redux/student/studentSlice";

import dptoInsUpdReducer from "../redux/dpto/dptoInsUpdSlice";
import dptoReducer from "../redux/dpto/dptoSlice";

import routineInsUpdReducer from "../redux/routine/routineInsUpdSlice";
import routineItemInsUpdReducer from "../redux/routine/routineItemInsUpdSlice";
import routineItemListReducer from "../redux/routine/routineItemListSlice";
import routineItemOptionInsUpdReducer from "../redux/routine/routineItemOptionInsUpdSlice";
import routineItemOptionListReducer from "../redux/routine/routineItemOptionListSlice";
import routineItemOptionReducer from "../redux/routine/routineItemOptionSlice";
import routineItemReducer from "../redux/routine/routineItemSlice";
import routineReducer from "../redux/routine/routineSlice";
// import routineRecordReducer from "../redux/routine/routineRecordSlice";
import routineCommentChangeReducer from "../redux/routine/routineCommentChangeSlice";
import routineCommentListReducer from "../redux/routine/routineCommentListSlice";
import routineRecordChangeReducer from "../redux/routine/routineRecordChangeSlice";
import routineRecordListReducer from "../redux/routine/routineRecordListSlice";

import imageInsReducer from "../redux/image/imageInsSlice";
import imageReviewReducer from "../redux/image/imageReviewSlice";
import imageSetAvatarReducer from "../redux/image/imageSetAvatar";
import imageReducer from "../redux/image/imageSlice";
import imagesReducer from "../redux/image/imagesSlice";
import imagesUploadReducer from "../redux/image/imagesUploadSlice";

import fileInsReducer from "../redux/file/fileInsSlice";
import filesUploadReducer from "../redux/file/filesUploadSlice";

import faceDetailsListReducer from "../redux/face/faceDetailsListSlice";
import faceQueryReducer from "../redux/face/faceQuerySlice";
import faceSetNobodyReducer from "../redux/face/faceSetNobodySlice";
import faceSetSomebodyReducer from "../redux/face/faceSetSomebodySlice";

import suggestionDetailsListReducer from "../redux/face/suggestion/suggestionDetailsListSlice";

import conversationCreateReducer from "../redux/conversation/conversationCreateSlice";
import conversationListReducer from "../redux/conversation/conversationListSlice";
import conversationPartyUsersReducer from "../redux/conversation/conversationPartyUsersSlice";
import conversationUpdReadReducer from "../redux/conversation/conversationUpdReadSlice";
import conversationUserReducer from "../redux/conversation/conversationUserSlice";
import massiveMessageReducer from "../redux/conversation/massive/massiveMessageSlice";
import massiveMessageUserReducer from "../redux/conversation/massive/massiveMessageUserSlice";
import messageDismissedReducer from "../redux/conversation/massive/messageDismissed";
import pureMessageReducer from "../redux/conversation/massive/pureMessageSlice";
import messageListReducer from "../redux/conversation/messageListSlice";
import messageSendMassiveReducer from "../redux/conversation/messageSendMassiveSlice";
import messageSendReducer from "../redux/conversation/messageSendSlice";
import selectedConversationReducer from "../redux/navigation/selectedConversationSlice";

import objectCacheReducer from "../redux/object/objectCacheSlice";

import surveyInsUpdReducer from "../redux/survey/surveyInsUpdSlice";
import surveyListReducer from "../redux/survey/surveyListSlice";
import surveyQuestionAnswerInsUpdReducer from "../redux/survey/surveyQuestionAnswerInsUpdSlice";
import surveyQuestionAnswerListReducer from "../redux/survey/surveyQuestionAnswerListSlice";
import surveyQuestionAnswerReducer from "../redux/survey/surveyQuestionAnswerSlice";
import surveyReducer from "../redux/survey/surveySlice";
import surveyQuestionTargetListReducer from "../redux/survey/surveyTargetListSlice";
import surveyTargetReducer from "../redux/survey/surveyTargetSlice";

import { presenceChangeClassroomSlice } from "../redux/curriculum/presenceChangeClassroomSlice";
import { presenceChangeSlice } from "../redux/curriculum/presenceChangeSlice";
import { presenceListSlice } from "../redux/curriculum/presenceListSlice";
import scheduleInsUpdReducer from "../redux/curriculum/scheduleInsUpdSlice";
import { scheduleListSlice } from "../redux/curriculum/scheduleListSlice";
import subjectInsUpdReducer from "../redux/curriculum/subjectInsUpdSlice";
import { subjectListSlice } from "../redux/curriculum/subjectListSlice";
import subjectPerformedInsUpdReducer from "../redux/curriculum/subjectPerformedInsUpdSlice";
import { subjectPerformedListSlice } from "../redux/curriculum/subjectPerformedListSlice";
import subjectReducer from "../redux/curriculum/subjectSlice";
import homeworkCheckChangeReducer from "../redux/homework/homeworkCheckChangeSlice";
import homeworkClassroomListReducer from "../redux/homework/homeworkClassroomListSlice";
import homeworkCommentChangeReducer from "../redux/homework/homeworkCommentChangeSlice";
import homeworkInsUpdReducer from "../redux/homework/homeworkInsUpdSlice";
import homeworkReportReducer from "../redux/homework/homeworkReportSlice";
import homeworkReducer from "../redux/homework/homeworkSlice";

export const store = configureStore({
  reducer: {
    user: userReducer,
    usersForPermissions: usersForPermissions,
    userPermissionInsDel: userPermissionInsDel,
    usersQuery: usersQuery,
    usersPermissionsIns: usersPermissionsIns,
    userInvite: userInviteReducer,
    createInvite: createInviteReducer,
    
    schools: schoolsReducer,
    school: schoolReducer,
    schoolInsUpd: schoolInsUpdReducer,
    schoolClassrooms: schoolClassroomsReducer,
    schoolStudents: schoolStudentsReducer,
    schoolDptos: schoolDptosReducer,
    schoolRoutines: schoolRoutinesReducer,

    classroom: classroomReducer,
    classroomInsUpd: classroomInsUpdReducer,
    classroomStudents: classroomStudentsReducer,
    classroomStudentAdd: classroomAddStudentReducer,
    classroomRemoveStudent: classroomRemoveStudentReducer,
    classroomStudentInvites: classroomStudentInvitesReducer,

    student: studentReducer,
    studentInsUpd: studentInsUpdReducer,
    studentClassrooms: studentClassroomsReducer,
    studentSchools: studentSchoolsReducer,
    studentInvite: studentInviteReducer,

    dpto: dptoReducer,
    dptoInsUpd: dptoInsUpdReducer,

    routine: routineReducer,
    routineInsUpd: routineInsUpdReducer,
    routineItem: routineItemReducer,
    routineItemList: routineItemListReducer,
    routineItemInsUpd: routineItemInsUpdReducer,
    routineItemOption: routineItemOptionReducer,
    routineItemOptionInsUpd: routineItemOptionInsUpdReducer,
    routineItemOptionList: routineItemOptionListReducer,
    // routineRecord: routineRecordReducer,
    routineRecordList: routineRecordListReducer,
    routineRecordChange: routineRecordChangeReducer,
    routineCommentChange: routineCommentChangeReducer,
    routineCommentList: routineCommentListReducer,

    image: imageReducer,
    imageSetAvatar: imageSetAvatarReducer,
    imageIns: imageInsReducer,
    imagesUpload: imagesUploadReducer,
    images: imagesReducer,
    imageReview: imageReviewReducer,

    fileIns: fileInsReducer,
    filesUpload: filesUploadReducer,

    faceDetailsList: faceDetailsListReducer,
    faceSetNobody: faceSetNobodyReducer,
    faceSetSomebody: faceSetSomebodyReducer,
    faceQuery: faceQueryReducer,

    suggestionDetailsList: suggestionDetailsListReducer,

    conversationList: conversationListReducer,
    conversationCreate: conversationCreateReducer,
    conversationUpdRead: conversationUpdReadReducer,
    conversationPartyUsers: conversationPartyUsersReducer,
    conversationUser: conversationUserReducer,
    messageList: messageListReducer,
    messageSend: messageSendReducer,
    messageSendMassive: messageSendMassiveReducer,
    massiveMessage: massiveMessageReducer,
    massiveMessageUser: massiveMessageUserReducer,
    messageDismissed: messageDismissedReducer,
    pureMessage: pureMessageReducer,
    selectedConversation: selectedConversationReducer,

    objectCache: objectCacheReducer,

    survey: surveyReducer,
    surveyList: surveyListReducer,
    surveyInsUpd: surveyInsUpdReducer,
    surveyTarget: surveyTargetReducer,
    surveyQuestionTargetList: surveyQuestionTargetListReducer,
    surveyQuestionAnswer: surveyQuestionAnswerReducer,
    surveyQuestionAnswerList: surveyQuestionAnswerListReducer,
    surveyQuestionAnswerInsUpd: surveyQuestionAnswerInsUpdReducer,

    homework: homeworkReducer,
    homeworkClassroomList: homeworkClassroomListReducer,
    homeworkInsUpd: homeworkInsUpdReducer,
    homeworkReport: homeworkReportReducer,
    homeworkCheckChange: homeworkCheckChangeReducer,
    homeworkCommentChange: homeworkCommentChangeReducer,

    subject: subjectReducer,
    subjectList: subjectListSlice.reducer,
    subjectInsUpd: subjectInsUpdReducer,
    scheduleList: scheduleListSlice.reducer,
    scheduleInsUpd: scheduleInsUpdReducer,
    subjectPerformedList: subjectPerformedListSlice.reducer,
    presenceList: presenceListSlice.reducer,
    subjectPerformedInsUpd: subjectPerformedInsUpdReducer,
    presenceChange: presenceChangeSlice.reducer,
    presenceChangeClassroom: presenceChangeClassroomSlice.reducer,
  },
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
